<template>
    <b-container fluid class="overview">
        <h1 class="text-left mb-4">
            {{ $t('themeGroups.titleThemeGroupsOverview') }}
        </h1>
        <b-badge v-if="loading" variant="primary">{{ $t('loading') }}</b-badge>
        <draggable-list
            v-if="themeGroups"
            :list="themeGroups"
            @update="$_onUpdateThemeGroupOrder"
            class="pl-0 mb-3"
        >
            <router-link
                :to="{
                    name: 'themeGroupDetail',
                    params: { id: themeGroup.id }
                }"
                tag="li"
                class="list-group-item pl-2"
                v-for="themeGroup in themeGroups"
                :key="themeGroup.id"
             >
                <i class="fa fa-arrows-alt"
                    aria-hidden="true"
                />
                {{ themeGroup.name }}
            </router-link>
        </draggable-list>
        <!-- Overig themegroup -->
        <router-link
            :to="{
                name: 'themeGroupDetail',
                params: { id: themeGroup.id }
            }"
            tag="li"
            class="list-group-item mt-3 pl-0 mb-3 mr-3"
            v-for="themeGroup in themeGroupOverig"
            :key="themeGroup.id"
            draggable="false"
        >
            <div class="ml-2">
                {{ themeGroup.name }}
            </div>
        </router-link>
        <router-links-footer :routerLinks="[{ name: 'themeGroupNew' }]"/>
        <!-- No content for overview -->
        <div
            v-if="(!themeGroups || themeGroups.length === 0) && themeGroupOverig.length === 0 && !loading"
            class="col-md-12">
            <span>{{ $t('themeGroups.nonePresent') }}</span>
	    </div>
    </b-container>
</template>

<script>
    import {
        numberSortFunction,
        nprogress
    } from '../../services/utilities/utilities';
    import { mapState } from 'vuex';
    import DraggableList from '../../components/BaseComponents/DraggableList.vue';
    import RouterLinksFooter from '../../components/dashboard/RouterLinksFooter.vue';
    import { THEMAGROUP_OVERIG } from '../../constants';

    export default {
        name: 'ThemeGroupsOverview',
        components: {
            'draggable-list': DraggableList,
            'router-links-footer': RouterLinksFooter
        },

        data: function () {
            return {
                sortBy: 'order',
                themeGroups: null,
                themeGroupOverig: [],
                themes: [],
                loading: null
            };
        },

        async created() {
            this.loading = true;
            const themeGroupsResult = await this.$store.dispatch('useApiData', {
                name: 'GetThemeGroups',
                parameters: {},
                useLoader: true
            });
            this.themeGroups = [...themeGroupsResult.data].sort(
                numberSortFunction('order')
            );
            await this.$_loadThemes();
            this.$_overigThemeGroup();
            this.loading = false;
        },
        computed: {
            ...mapState(['userInfo'])
        },

        methods: {
            async $_onUpdateThemeGroupOrder(value) {
                this.loading = true;
                const oldThemeGroups = JSON.parse(JSON.stringify(this.themeGroups));
                let themeGroups = JSON.parse(JSON.stringify(this.themeGroups));
                themeGroups = themeGroups.map((group) => ({
                        ...group,
                        order: value.findIndex(({ id }) => id === group.id)
                    }))
                    .sort(numberSortFunction(this.sortBy));
                this.themeGroups = themeGroups;
                try {
                    await Promise.all(themeGroups.map(this.$_onSave));
                } catch (error) {
                    this.themeGroups = oldThemeGroups;
                    this.loading = false;
                    const data = {
                        message: this.$t(error.message),
                        variant: 'danger',
                        title: this.$t(error.title),
                        autoHideDelay: 5000
                    };
                    this.showToast(data);
                }
                this.loading = false;
            },
            $_onSave(body) {
                const name = 'UpdateThemeGroup';
                return this.$store.dispatch('useApiData', {
                    name: name,
                    useLoader: true,
                    parameters: { Id: body.id },
                    data: body
                });
            },
            async $_loadThemes() {
                nprogress.start();
                try {
                    if (this.themes.length === 0) {
                        const result = await this.$store.dispatch('useApiData', {
                            name: 'GetThemeOverview'
                        });
                        let themes = Object.assign([], result?.data);

                        // fill array with all themes titles
                        themes.forEach((record) => {
                            if (!record.themeGroup) {
                                this.themes.push({
                                    themeName: record.name,
                                    themeId: record.id,
                                    order: 0
                                });
                            }
                        });
                    }
                    nprogress.done();
                } catch (error) {
                    nprogress.done();
                    const data = {
                        message: error.message,
                        variant: 'danger',
                        autoHideDelay: 10000
                    };
                    this.showToast(data);
                }
            },
            $_overigThemeGroup() {
                let organizationId = this.userInfo.organizationId;
                if (this.themes.length > 0) {
                    this.themeGroupOverig.push(
                    {
                        id: THEMAGROUP_OVERIG.NR,
                        name: THEMAGROUP_OVERIG.NAME,
                        order: THEMAGROUP_OVERIG.NR,
                        organizationId,
                        organizationThemeGroupThemes: null
                    });
                }
            }
        }
    };
</script>

<style scoped lang="scss">
.list-group-item {
    padding: 0.3rem;
    cursor: pointer;

    &:nth-child(odd) {
        background: $black-transparent-05;
    }

    &:hover {
        background: $gray-03;
    }

    .fa-arrows-alt:hover {
        cursor: move;
    }
}
</style>
